export function classNames(...rest: (string | number | { [key in string]: string } | undefined)[]): string {
  const classes = [];

  for (let i = 0; i < arguments.length; i++) {
    const arg = rest[i];
    if (!arg) continue;

    if (typeof arg === 'string' || typeof arg === 'number') {
      classes.push(arg);
    } else if (Array.isArray(arg)) {
      if (arg.length > 0) {
        const inner = classNames(arg);
        if (inner) {
          classes.push(inner);
        }
      }
    } else if (typeof arg === 'object') {
      if (arg.toString !== Object.prototype.toString) {
        classes.push(arg.toString());
      } else {
        for (const key in arg) {
          // We can't assume that an object will have properties from Object.prototype, it's better
          // to call this methods on the prototype directly.
          if (Object.hasOwn(arg, key) && arg[key]) {
            classes.push(key);
          }
        }
      }
    }
  }

  return classes.join(' ');
}
